export default "__VITE_ASSET__BBijtnKu__"